import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../../../core/services/auth/auth.service';
import { BookingService } from '../../../../core/services/booking.service';
import { Router } from '@angular/router';

@Component({
	selector: 'app-pre-booking',
	templateUrl: './pre-booking.component.html',
	styleUrls: ['./pre-booking.component.scss']
})
export class PreBookingComponent implements OnInit {
	public date: string;
	public plant: string;
	public hour: string;

	constructor(
		private authService: AuthService,
		private bookingService: BookingService,
		private route: Router
	) { }
	
	ngOnInit() {
		this.getData();
	}

	getData() {
		this.bookingService.getPlantPrebookingData().subscribe((response) => {
			this.date = response.date;
			this.hour = response.hour;
			this.plant = response.plant;
			if (this.date === undefined) {
				this.route.navigateByUrl('/');
			}
		});
	}
}
